import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { switchMap, tap } from "rxjs/operators";

import { AuthenticationService } from "../_services/authentication.service";
import { LocalStorageService } from "../_services/browser-apis/local-storage.service";

@Injectable()
export class LoginGuard {
  private authService = inject(AuthenticationService);
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);

  canActivate(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isDoneLoading$.pipe(
      switchMap(() => this.authService.isAuthenticated$),
      tap(isAuthenticated => {
        if (isAuthenticated) {
          const lastVisitedRoute =
            this.localStorageService.getItem("lastVisitedRoute");
          if (lastVisitedRoute) {
            void this.router.navigate([lastVisitedRoute], {
              queryParamsHandling: "preserve",
            });
            this.localStorageService.removeItem("lastVisitedRoute");
          } else {
            void this.router.navigate(["/doc-upload"], {
              queryParamsHandling: "preserve",
            });
          }
          return true;
        }
        void this.authService.login(state.url);

        return false;
      })
    );
  }
}
